:host {
  display: inline-block;
}

.o2-picture {
  display: inline-block;
}

img.lazy {
  width: 100%;
  opacity: 0;
  object-fit: contain;
  max-width: 100%;
  max-height: 100%;

  &.loaded {
    transition: opacity 0.3s ease-in-out;
    opacity: 1;
  }

  &.error {
    opacity: 1;
  }
}
